export type ExportTargetTabName =
  | 'Overview'
  | 'Removed'
  | 'Requested'
  | 'Scanned'
  | 'Flagged'
  | 'Seller'
  | 'Compliance'
  | 'Reviewed'
  | 'Reported';

export enum ExportExcelChartType {
  scanned_time_series = 'scanned_time_series',
  scanned_top10 = 'scanned_top10',
  flagged_time_series = 'flagged_time_series',
  flagged_top10 = 'flagged_top10',
  reviewed_time_series = 'reviewed_time_series',
  reviewed_top10 = 'reviewed_top10',
  reported_time_series = 'reported_time_series',
  reported_top10 = 'reported_top10',
  requested_time_series = 'requested_time_series',
  requested_top10 = 'requested_top10',
  removed_time_series = 'removed_time_series',
  removed_top10 = 'removed_top10',
  seller_top10 = 'seller_top10',
  compliance_time_series = 'compliance_time_series',
  compliance_top10 = 'compliance_top10',
  cohort = 'cohort',
}

export enum EnforcementTopListTabEnum {
  Country = 'country',
  Platform = 'platform',
  Asset = 'asset',
  InfringementType = 'infringement_type',
}
